module.exports = __webpack_public_path__ + "static/img/h5-12.b23d9a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-12.png
// module id = YTkL
// module chunks = 1